import React, { useEffect, useState, useContext } from "react";
import { MessageContext } from "assets/js/syntax";
import client from "assets/js/commonApi";
import { Box, Container } from "@mui/material";
import DataGridLayout from "components/grid/DataGridLayout";
// import { ModalDirectContract } from "components/modal/ModalDirectContract";
// import { ModalPlatformContract } from "components/modal/ModalPlatformContract";
import SearchBaseForm from "components/searchForm/SearchBaseForm";
import BasicTooltip from "components/tooltips/BasicTooltip";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const ConsignmentList = () => {
  // const { triggerRefresh } = useContext(MessageContext);
  const [rowsData, setRowsData] = useState([]); // 계약 목록 데이터
  const [isDataLoading, setIsDataLoading] = useState(false); // 추가된 로딩 상태
  const [stepOptions, setStepOptions] = useState([]); // 검색창 옵션 데이터
  const [stepValue, setStepValue] = useState({}); // 검색창 상태(진행상황) 값, label
  const [stepInputValue, setStepInputValue] = useState(""); // 검색창 옵션 선택(진행상황 입력값) 값
  const [contractNumber, setContractNumber] = useState(""); // 계약 목록 데이터 - 계약번호 - 상태값을 저장하여 검색 기능 구현시 사용
  const [selectContractNumber, setSelectContractNumber] = useState(); // 선택된 계약번호(계약서내 계약번호)
  const [isOpenModal, setIsOpenModal] = useState(false); // 계약서 모달창 open, close
  // 날짜 상태 관리
  const [fromDtm, setFromDtm] = useState(dayjs().subtract(30, "day"));
  const [toDtm, setToDtm] = useState(dayjs());

  console.log("##### selectContractNumber", selectContractNumber);
  console.log("##### stepValue", stepValue);
  console.log("##### stepInputValue", stepInputValue);
  console.log("##### stepOptions", stepOptions);
  console.log("##### contractNumber", contractNumber);
  console.log("##### isOpenModal", isOpenModal);

  // useEffect를 사용하여 컴포넌트가 마운트되었을 때 데이터를 불러옴
  useEffect(() => {
    GetData(fromDtm, toDtm);
  }, []); // 빈 배열을 넘겨주면 컴포넌트가 마운트될 때만 실행됨

  const GetData = (fromDtm, toDtm) => {
    setIsDataLoading(true); // 데이터 로딩 시작
    // console.log("#### Received fromDate:", fromDtm); // 디버깅을 위한 로그
    // console.log("#### Received toDate:", toDtm);

    const from = dayjs(fromDtm);
    const to = dayjs(toDtm);

    console.log("#### Formatted fromDate:", from.format("YYYY-MM-DD"));
    console.log("#### Formatted toDate:", to.format("YYYY-MM-DD"));

    if (!from.isValid() || !to.isValid()) {
      console.error("Provided dates are not valid.");
      // console.error("####@@@@ Provided dates are not valid:", fromDtm, toDtm);
      return;
    }

    client
      .post("/platformsell/list", {
        // from_dtm: from,
        // to_dtm: to,
        // contract_sub_id: contractNumber,
        to_dtm: to.format("YYYY-MM-DD"),
        from_dtm: from.format("YYYY-MM-DD"), // 서버에서 처리할 수 있는 문자열 형태로 전송

        // .post("/mdpt_agree/select/", {
        // contract_sub_id: contractNumber,
        step_type: stepValue ? stepValue.value : "", // stepValue가 null이 아닌 경우에만 접근
      })
      .then((res) => {
        // const rows = res.data.data ? res.data.data : [];
        if (!res.data || !res.data.data) {
          console.error("No data received or incorrect data path.");
          return;
        }
        const filteredRows = res.data.data.filter((item) => {
          // const insDate = dayjs(item.ins_dtm);
          const insDate = dayjs(item.ins_dtm);
          console.log("#### insDate:", insDate.format("YYYY-MM-DD"));
          // const insDate = dayjs(item.ins_dtm).format("YYYY-MM-DD");
          return (
            insDate.isValid() &&
            insDate.isSameOrAfter(from, "day") &&
            insDate.isSameOrBefore(to, "day")
          );
        });
        console.log("##@@@@ Filtered Rows:", filteredRows);
        setRowsData(
          filteredRows.map((item, index) => ({
            ...item,
            id: index + 1,
            dtm: `${item.from_dtm?.substring(0, 10)} ~ ${item.to_dtm?.substring(
              0,
              10,
            )}`,
            doc: "계약서",
          })),
        );

        console.log("New RowsData:", rowsData);
      })
      .catch((err) => {
        console.error("## Error in GetData:", err);
      })
      .finally(() => {
        setIsDataLoading(false); // 데이터 로딩 완료
      });
  };

  // const handleClickOpen = (params) => {
  //   console.log("## params", params);
  //   console.log("## handleClickOpen", handleClickOpen);
  //   // alert("handleClickOpen");
  //   setIsOpenModal(true);
  //   // setSelectDid(params.row.did_buyer);
  //   setSelectContractNumber(params.row.contract_sub_id);
  // };

  // 이벤트를 무시하는 핸들러를 정의
  // const handleCellClick = (params, event) => {
  //   event.stopPropagation(); // 클릭 이벤트를 무시하거나 필요에 따라 다른 동작을 수행
  // };

  const handleCellClick = (params, event) => {
    // `event`가 undefined인 경우를 방지
    if (event) {
      event.stopPropagation(); // 이벤트 전파 중지
    }
  };

  const handleClose = () => {
    setIsOpenModal(false);
    GetData();

    // // 새로운 날짜 범위 계산
    // const newFromDtm = dayjs().subtract(30, "day");
    // const newToDtm = dayjs();
    // // 데이터 새로고침
    // GetData(newFromDtm, newToDtm);
  };

  const columns = [
    {
      field: "id",
      headerName: "No.",
      flex: 0.1,
    },
    {
      field: "contract_sub_id",
      headerName: "계약 번호",
      // type: "String",
      // width: 150,
      flex: 1.5,
      // editable: true,
      // disableColumnFilter: "true",
      renderCell: (params) => (
        <BasicTooltip title={params.row.contract_sub_id} />
      ),
      valueGetter: ({ value }) => value || "-", // 데이타 값이 없을 때
    },
    {
      field: "seller_name",
      headerName: "판매자",
      flex: 0.65,
      // editable: true,
      renderCell: (params) => <BasicTooltip title={params.row.seller_name} />,
    },
    {
      field: "buyer_name",
      headerName: "구매자",
      // width: 100,
      // flex: 0.75,
      flex: 0.65,
      // editable: true,
      renderCell: (params) => <BasicTooltip title={params.row.buyer_name} />,
    },
    {
      field: "contract_title",
      headerName: "제목",
      // type: "date",
      // width: 150,
      // flex: 1,
      flex: 1.65,
      // editable: true,
      renderCell: (params) => (
        <BasicTooltip title={params.row.contract_title} />
      ),
    },
    {
      field: "dtm",
      headerName: "계약기간",
      // type: "date",
      // width: 150,
      flex: 1.7,
      // editable: true,
      renderCell: (params) => <BasicTooltip title={params.row.dtm} />,
    },
    // {
    //   field: "sign_seller_dtm",
    //   headerName: "구매자서명",
    //   // width: 80,
    //   flex: 0.65,
    //   renderCell: (params) => (
    //     <BasicTooltip title={params.row.sign_seller_dtm} />
    //   ),
    // },
    {
      field: "doc",
      headerName: "계약서",
      // width: 80,
      flex: 0.65,
    },
    {
      field: "code_name",
      headerName: "진행상황",
      // width: 100,
      // flex: 0.75,
      flex: 1.25,
      // flex: 0.55,
      // editable: true,
      renderCell: (params) => <BasicTooltip title={params.row.code_name} />,
    },
  ];
  const datagridSx = {
    border: "0",
    "& .MuiDataGrid-root": {
      border: "0px !important",
    },
    "& .MuiDataGrid-main": {},
    "& .MuiDataGrid-root--densityStandard": {},
    "& .MuiDataGrid-withBorderColor": {
      border: 0,
    },
    '& div[data-rowIndex][role="row"]:nth-of-type(5n-4)': {
      // color: "blue",

      "& div": {
        // minHeight: "60px !important",
        // height: 60,
        // lineHeight: "59px !important",
      },
    },
    "& .MuiDataGrid-virtualScrollerRenderZone": {
      "& .MuiDataGrid-row": {
        // "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
        "&:nth-of-type(2n)": { backgroundColor: "rgba(238, 242, 245, 1)" },
      },
    },
    // "& .MuiDataGrid-cell:hover:nth-of-type(7)": {
    //   cursor: "pointer !important",
    //   color: "red",
    // },
    "& .MuiDataGrid-cell:nth-of-type(7)": {
      pointerEvents: "none",
      color: "rgba(0, 0, 0, 0.26)",
      // "& .MuiDataGrid-cellContent": {
      //   borderBottom: "1px solid #000",
      //   // pointerEvents: "none", // 'doc' 필드에 대한 포인터 이벤트를 무시
      // },
    },

    // pointer cursor on ALL rows
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      // backgroundColor: "rgba(0,0,255,0.6)",
      // color: "rgba(255,0,0,0.7)",
      fontSize: 14,
      minHeight: "55px !important",
      maxHeight: "55px !important",
      lineHeight: "55px !important",
      borderTop: "#29314A 3px solid",
      borderBottom: "#29314A 3px solid",

      borderRadius: "0px !important",
    },
    "& .MuiDataGrid-footerContainer": {
      // backgroundColor: "rgba(0,0,255,0.6)",
      // color: "rgba(255,0,0,0.7)",
      fontSize: 14,
      minHeight: "40px !important",
      maxHeight: "40px !important",
      lineHeight: "40px !important",
    },
  };

  return (
    <>
      <Box>
        <Container sx={{ p: "0 !important" }}>
          <SearchBaseForm
            // onClick={GetData}
            onSearch={GetData}
            fromDtm={fromDtm}
            toDtm={toDtm}
            setFromDtm={setFromDtm}
            setToDtm={setToDtm}
          />
          <Box>
            <DataGridLayout
              rows={rowsData}
              // rows={partner}
              columns={columns}
              // onCellClick={handleClickOpen}
              onCellClick={handleCellClick}
              sx={datagridSx}
              isDataLoading={isDataLoading}
            />
            {/* {isOpenModal && (
              <ModalDirectContract
                // did={selectDid}
                contract_sub_id={selectContractNumber}
                // open={isOpenModal}
                company_info_type="buyer"
                onClose={handleClose}
              />
            )} */}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ConsignmentList;
